import { fmt } from '../../utils/common';
import React from 'react';

export const DeltaChip: React.FC<{ value: number; isPositiveGreen?: boolean }> = ({
  value,
  isPositiveGreen = true,
}) => {
  const isPositive = value >= 0;
  const color = isPositiveGreen
    ? isPositive
      ? 'success'
      : 'danger'
    : isPositive
    ? 'danger'
    : 'success';
  return (
    <span className={`delta-chip delta-${color}`}>
      {isPositive ? '+' : ''}
      {fmt(value)}
    </span>
  );
};
